
; (function ($, window, document, undefined) {

  const matchkassa = $('html.matchkassa');
  if (!matchkassa || matchkassa.length==0) {
    return;
  }


  var $ripple = $('.btn-ripple');
  $ripple.each(function (index) {
    const div = document.createElement("div");
    div.classList.add("div-ripple");

    const circle = document.createElement("span");
    const diameter = Math.max($(this).clientWidth, $(this).clientHeight);
    circle.style.width = circle.style.height = `${diameter}px`;
    circle.classList.add("span-ripple");

    $(div).append(circle);
    $(this).prepend(div);

    $(this).click(function (e) {
      if ($(this)[0].href != undefined) {
        e.preventDefault();
      }
      var $this = $(this);
      var $div = $this.find('.div-ripple');
      var $offset = $this.offset();
      var $circle = $this.find('.span-ripple');

      var x = e.pageX - $offset.left;
      var y = e.pageY - $offset.top;

      $circle.css({
        top: y + 'px',
        left: x + 'px'
      });

      $div.addClass('is-active');
      if ($(this)[0].href != undefined) {
        setTimeout(function () { location.href = $this[0].href; }, 500);
      } else {
        // SUBMIT IN FORM
        //var b = setTimeout(function () { $this[0].click(); b = clearTimeout(); }, 500);
      }
    });

    $(div).on('animationend webkitAnimationEnd oanimationend MSAnimationEnd', function (e) {
      $(this).removeClass('is-active');
    });
  });


  var $btnsplash = $('.btn-jsSplash .div-ripple');
  $btnsplash.each(function (index) {
    $(this).click(function () {

      var $splash = $('#splash');
      if (!$splash[0]) {
        const div = document.createElement("div");
        div.id = "splash";
        $('body').prepend(div);
        $(div).fadeIn(400);
        setTimeout(function () { $(div).fadeOut(400); }, 5000);
      } else {
        $($splash[0]).fadeIn(400);
        setTimeout(function () { $($splash[0]).fadeOut(400); }, 5000);
      }

    });
  });

})(jQuery, window, document);